import React from 'react';
import IceCreamBanner from '../banners/Icecream-Banner/IceCreamBanner';
import IceCreamList from '../sections/IceCream/IceCreamList';
import Header from '../components/Header/Header';

const IceCream = () => {
  return (
    <div className="ice-cream-page">
      <Header />
      <IceCreamBanner />
      <div className="ice-cream-list-section">
        <IceCreamList />
      </div>
    </div>
  );
};

export default IceCream; 